<script>
import Layout from "@/views/Layout.vue";
import {get, post} from "@/utils/api";

export default {
  name: "EncoursAgence",
  components: {
    Layout,
  },
  props: {},
  data() {
    return {
      searchform: {
        bookingDateStart: null,
        bookingDateStop: null,
        paymentTerms: [2],
      },
      dialog: false,
      paymentTerms: [],
      listing: {
        rowsPerPageItems: [{text: "Tous", value: -1}, 50, 200],
        pagination: {
          options: {
            page: 1,
            itemsPerPage: 200,
            sortBy: [],
            sortDesc: [false],
          },
        },
        loading: false,
        headers: [
          {
            text: "Agence",
            value: "agencyName",
          },
          {
            text: "Réseau",
            value: "networkName",
          },
          {
            text: "Nb dossiers",
            value: "nbFolders",
          },
          {
            text: "Montant dossiers",
            value: "unpaidTotal",
          },

        ],
        items: [],
      },
      details: {
        loading: false,
        headers: [],
        items: [],
        pagination: {
          page: 1,
          itemsPerPage: 50,
        },
      },
    }
  },
  created() {
    this.getPaymentTerms()
    this.search();
  },
  computed: {
    searchable() {
      return this.listing.loading
    }
  },
  methods: {
    async search() {
      if (!this.listing.loading) {
        await this.getData();
      }
    },
    openDetails(item) {
      this.dialog = true;
      this.details.headers = [
        {
          text: item.bookingIds.length > 1 ? 'Dossiers' : 'Dossier',
          value: "bookingId",
          align: "left",
          sortable: true,
          width: 30,
        },
      ];
      this.details.items = item.bookingIds.map(id => ({bookingId: id}));
    },
    getPaymentTerms(){
      const url="/api/search/paymentterms"

      get(url).json((data) => {
        this.paymentTerms = data.map((item) => item.id).sort((a, b) => a - b);
      });
    },
    async getData() {
      this.listing.loading = true;
      const url = "/api/widget/agency-stats/unpaid";
      this.listing.items = [];

      const body = {
        bookingDateStart: this._parseAndFormatDate(this.searchform.bookingDateStart, "dd/MM/yyyy", "yyyy-MM-dd"),
        bookingDateStop: this._parseAndFormatDate(this.searchform.bookingDateStop, "dd/MM/yyyy", "yyyy-MM-dd"),
        paymentTerms: this.searchform.paymentTerms
      }

      return post(url, body)
          .json((data) => {
            this.listing.items = data;
          })
          .then(() => {
            this.listing.loading = false;
          });
    },
  },
}
</script>

<template>
  <layout :drawerShow="_isDesktop()" :drawerWidth="300">
    <template slot="drawer">
      <v-form
          ref="searchform"
          v-if="searchform"
          v-on:submit.prevent="search()"
      >
        <v-row justify="start" class="mt-1">
          <v-subheader light class="form-subheader solo-subheader">Date de réservation</v-subheader>
          <v-col cols="6" class="pt-0">
          <smart-picker
              v-model="searchform.bookingDateStart"
              :stopDate="searchform.bookingDateStop"
              :inputOpts="{ label: $t('begin') }"
          />
          </v-col>
          <v-col cols="6" class="pt-0">
            <smart-picker
                v-model="searchform.bookingDateStop"
                :startDate="searchform.bookingDateStart"
                :inputOpts="{ label: $t('end') }"
            />
          </v-col>
          <v-col cols="12" class="mt-4">
          <v-select
              dense
              label="Payment terms"
              v-model="searchform.paymentTerms"
              :items="paymentTerms"
              hide-details
              hide-no-data
              multiple
          ></v-select>
          </v-col>
        </v-row>
        <v-col cols="12">
        </v-col>
        <smart-btn
            :loading="listing.loading"
            type="submit"
            block
            primary
            @click="search"
            :disabled="searchable">
          Rechercher
        </smart-btn>
      </v-form>
    </template>
    <template slot="content">
      <v-container fluid>
        <div class="mt-1" style="max-width:1024px;margin:auto">
          <v-row>
            <v-col cols="12" class="">
              <v-data-table
                  :header-props="{ sortByText: 'Trier par' }"
                  :headers="listing.headers"
                  :loading="listing.loading"
                  :items="listing.items"
                  :options.sync="listing.pagination"
                  class="elevation-1 tbl"
                  no-data-text="Il n'y a pas d'agences à afficher"
                  @click:row="openDetails"
              >
                <template #item.agencyName="{ item }">
                  {{ item.agencyName }}
                </template>
                <template #item.networkName="{ item }">
                  {{ item.networkName ? item.networkName : "aucun" }}
                </template>
                <template #item.nbFolders="{ item }">
                  {{ item.bookingIds ? item.bookingIds.length : 0 }}
                </template>
                <template #item.unpaidTotal="{ item }">
                  {{ _formatCurrency(item.unpaidTotal, 'EUR') }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>

        <v-dialog v-model="dialog" width="800">
          <v-card>
            <v-card-title>Liste des dossiers</v-card-title>
            <v-card-text>
              <v-data-table
                  :headers="details.headers"
                  :loading="details.loading"
                  :items="details.items"
                  :options.sync="details.pagination"
                  :footer-props="{
                      itemsPerPageOptions: [10, 50, 100, -1],
                      itemsPerPageText: 'Lignes par page'
                    }"
                  dense
                  class="elevation-1 tbl"
              >
                <template #item.bookingId="{ item }">
                  {{ item.bookingId }}
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-row justify="end">
                <v-col cols="2" class="mr-4">
                  <smart-btn secondary @click.native="dialog = false"
                  >Fermer
                  </smart-btn
                  >
                </v-col
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </template>
  </layout>
</template>